import { useUser } from "src/hooks/useUser";

export const useExternalUser = () => {
    const { data: user, isLoading } = useUser();
    if (isLoading) {
        return undefined;
    }
    return user?.info.roles.includes("external") ?? false;
};
